import { render, staticRenderFns } from "./tan_file_type.vue?vue&type=template&id=6c80ca64&scoped=true"
import script from "./tan_file_type.vue?vue&type=script&lang=js"
export * from "./tan_file_type.vue?vue&type=script&lang=js"
import style0 from "./tan_file_type.vue?vue&type=style&index=0&id=6c80ca64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c80ca64",
  null
  
)

export default component.exports